export function getReportRouteCodes(routes: readonly { path: string }[]): ReadonlySet<string> {
  return new Set(
    routes.map(route => {
      const prefix = "/admin/report/";
      if (route.path.startsWith(prefix)) {
        return route.path.slice(prefix.length);
      }
      return route.path;
    }),
  );
}
